var map = {
	"./React-icon.png": 44,
	"./git-icon.png": 855,
	"./javascript-icon.png": 1544,
	"./logo.png": 6928,
	"./node-icon.png": 3315,
	"./php-icon.png": 8947,
	"./python-icon.jpg": 6057,
	"./python-icon.png": 321,
	"./sql-icon.png": 3651,
	"./ts-icon.png": 4874,
	"./wordpress-icon.png": 3924
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;